<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ animalAccounting.transReportName }}</h1>
    <div class="account-card-view">
      <div class="bgw-pdg-20">
        <div class="table-overflow">
          <div class="table-flex">
            <!-- Область -->
            <div class="table-item">
              <table>
                <tbody>
                <tr>
                  <td class="td-title">{{ $t('Область') }}</td>
                  <td>{{ animalAccounting.transSoateName }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formUngulate ||
                     animalAccounting.reportId === forms.formIlbirs ||
                     animalAccounting.reportId === forms.formVisual ||
                     animalAccounting.reportId === forms.formTrack ||
                     animalAccounting.reportId === forms.formStrength ||
                     animalAccounting.reportId === forms.formMarmot ||
                     animalAccounting.reportId === forms.formOndatra"
                >
                  <td class="td-title">{{ $t('Участок') }}</td>
                  <td>{{ animalAccounting.transObservePlotName }}</td>
                </tr>
                <tr>
                  <td class="td-title">{{ $t('Организация') }}</td>
                  <td>{{ animalAccounting.transOoptName }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formUngulate ||
                animalAccounting.reportId === forms.formIlbirs ||
                animalAccounting.reportId === forms.formTrack ||
                animalAccounting.reportId === forms.formVisual"
                >
                  <td class="td-title">{{ $t('Ущелье') }}</td>
                  <td>{{ animalAccounting.transCanyonName }}</td>
                </tr>
                <tr>
                  <td class="td-title">{{ animalAccounting.reportId === forms.formStrength || animalAccounting.reportId === forms.formMarmot || animalAccounting.reportId === forms.formNumberAnimal ? 'Составитель' : 'Наблюдатель' }}</td>
                  <td>{{ animalAccounting.transObserverFio }} {{ animalAccounting.transObserverPosition }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formMarmot || animalAccounting.reportId === forms.formNumberAnimal">
                  <td>{{ $t('Вид животного') }}</td>
                  <td>{{ animalAccounting.fauna ? animalAccounting.fauna.transName : '' }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formMarmot">
                  <td>{{ $t('Сум. площадь сурочьих поселений') }}</td>
                  <td>{{ animalAccounting.sumAreaMarmot }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
                  <td class="td-title">{{ $t('№ команды учетчиков') }}</td>
                  <td>{{ animalAccounting.teamNumber }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formUngulate ||
                 animalAccounting.reportId === forms.formTrack ||
                 animalAccounting.reportId === forms.formVisual ||
                 animalAccounting.reportId === forms.formIlbirs"
                >
                  <td class="td-title">ПП№</td>
                  <td>{{ animalAccounting.number }}</td>
                </tr>
                <tr>
                  <td class="td-title">{{ animalAccounting.reportId === forms.formStrength || animalAccounting.reportId === forms.formMarmot || animalAccounting.reportId === forms.formNumberAnimal ? 'Дата и время' : 'Дата и время наблюдения' }}</td>
                  <td>
                    {{ computedDateFormatted }}
                  </td>
                </tr>
                <tr>
                  <td class="td-title">{{ animalAccounting.reportId === forms.formStrength ? 'На начало года' : 'Год учета' }}</td>
                  <td>{{ animalAccounting.year.view }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formStrength">
                  <td class="td-title">{{ $t('Площадь') }}</td>
                  <td>{{ animalAccounting.observePlotArea }}</td>
                </tr>
                <tr v-if="animalAccounting.reportId === forms.formStrength">
                  <td class="td-title">{{ $t('Площадь, охваченная учетом') }}</td>
                  <td>{{ animalAccounting.areaCovered }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Статус') }}</td>
                  <td>
                    {{ animalAccounting.transStatusName }}
                    <div class="history-report">
                      <v-menu
                        v-model="historyDialog"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <a v-on="on"
                          ><v-icon class="icon-history">history</v-icon>{{ $t('История') }}</a
                          >
                        </template>
                        <v-list dense class="history-list history-list-table">
                          <v-list-item
                            two-line
                          >
                            <v-list-item-content>
                              <div class="table-overflow">
                                <table>
                                  <tbody>
                                    <tr
                                      v-for="history in histories"
                                      :key="'history_'+history.id"
                                    >
                                      <td>{{ new Date(history.createdDate) | dateFormat('DD.MM.YYYY') }}</td>
                                      <td>{{ history.transStatusName }}</td>
                                      <td>{{ history.userShortFio }}</td>
                                      <td>{{ history.comment }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- № точки GPS -->
            <div class="table-item" v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
              <table>
                <tbody>
                <tr>
                  <td>
                    {{ $t('№ точки GPS') }}
                  </td>
                  <td>
                    {{ animalAccounting.gpsNumber }}
                    <template v-if="animalAccounting.longitude && animalAccounting.latitude">
                      <v-icon color="#0096BB"
                              @click="runMap([parseFloat(animalAccounting.longitude), parseFloat(animalAccounting.latitude)])">
                        mdi-map-marker
                      </v-icon>
                      <v-dialog
                        v-model="mapDialog"
                        persistent
                      >
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            {{ $t('Точка на карте') }}
                          </v-card-title>
                          <v-card-text>
                            <MapPointView ref="mapRef" @cancel="mapDialog = false"/>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Долгота') }}</td>
                  <td>
                    <div class="flexbox">
                      <div class="td-item">
                        {{ animalAccounting.longitude }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Широта') }}</td>
                  <td>
                    <div class="flexbox">
                      <div class="td-item">
                        {{ animalAccounting.latitude }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Высота н.у.м') }}</td>
                  <td>{{ animalAccounting.altitude }}</td>
                </tr>
                <tr v-if="animalAccounting.gpx">
                  <td>GPX-файл</td>
                  <td><a :href="baseUrl + animalAccounting.gpx.link" target="_blank">{{ animalAccounting.gpx.name }}</a></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Угодия -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formTrack || animalAccounting.reportId === forms.formVisual">
            <table>
              <tbody>
              <tr v-if="animalAccounting.routeLength">
                <td>{{ $t('Длина маршрута') }}</td>
                <td>
                  {{ animalAccounting.routeLength }}
                  <span>км</span>
                </td>
              </tr>
              <tr v-if="animalAccounting.snowDepth">
                <td>{{ $t('Высота снежного покрова') }}</td>
                <td>
                  {{ animalAccounting.snowDepth }}
                  <span>см</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t('Тип угодий') }}</td>
                <td>{{ animalAccounting.transLandTypeName }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица учета животных по следам -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formTrack">
            <h6>Таблица учета животных по следам</h6>
            <table>
              <thead>
              <tr>
                <td rowspan="2">№</td>
                <td rowspan="2">{{ $t('Вид животного') }}</td>
                <td colspan="2">{{ $t('Отмечено следов на маршруте') }}</td>
              </tr>
              <tr>
                <td>1-й день (затирки следов)</td>
                <td>2-й день (учета)</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trace, i) in animalAccounting.traces" :key="i">
                <td>{{ i+1 }}</td>
                <td>{{ trace.transFaunaName }}</td>
                <td>{{ trace.numberTracesBefore }}</td>
                <td>{{ trace.numberTracesAfter }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица визуального учета животных -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formVisual">
            <h6>{{ $t('Таблица визуального учета животных') }}</h6>
            <table>
              <thead>
                <tr>
                  <td>№</td>
                  <td>{{ $t('Вид животного') }}</td>
                  <td>{{ $t('Расстояние до объекта (м)') }}</td>
                  <td>{{ $t('Количество животных (голов)') }}</td>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(meetingList, i) in animalAccounting.meetingLists" :key="i">
                <td>{{ i+1 }}</td>
                <td>{{ meetingList.transFaunaName }}</td>
                <td>{{ meetingList.objectDistance }}</td>
                <td>{{ meetingList.animalQuantity }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица сведения по численности -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formStrength">
            <h6>{{ $t('Сведения по численности животных') }}</h6>
            <table>
              <thead>
              <tr>
                <td>{{ $t('Вид животного') }}</td>
                <td>{{ $t('Урочище') }}</td>
                <td>{{ $t('Количество животных') }}</td>
              </tr>
              </thead>
              <tbody v-for="item in animalAccounting.strengthArray" :key="item.id">
                  <tr>
                    <td :rowspan="item.otherCanyon.length + 3" colspan="1">
                      {{ item.transFaunaName }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ item.transCanyonName }}
                    </td>
                    <td>
                      {{ item.strength }}
                    </td>
                  </tr>
                  <tr v-for="i in item.otherCanyon" :key="i.id">
                    <td>
                      {{ i.transCanyonName }}
                    </td>
                    <td>
                      {{ i.strength }}
                    </td>
                  </tr>
                  <tr>
                    <td><span>{{ $t('Итого по хозяйству') }}</span></td>
                    <td>{{total(item.strength,item.otherCanyon)}}</td>
                  </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица Ведомость маршрутов сурков -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formMarmot">
            <h6>{{ $t('Ведомость маршрутов') }}</h6>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td>{{ $t('Дата и время учета') }}</td>
                  <td>{{ $t('№ маршрута') }}</td>
                  <td>{{ $t('Длина маршрута (км)') }}</td>
                  <td>{{ $t('Ширина учетной полосы (м)') }}</td>
                  <td>{{ $t('Площадь маршрута (га)') }}</td>
                  <td>{{ $t('Учтено без ПК (голов)') }}</td>
                  <td>{{ $t('ПК') }}</td>
                  <td>{{ $t('Учтено с ПК (голов)') }}</td>
                  <td>{{ $t('Плот-сть на 1 га (голов)') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(marmot, i) in animalAccounting.marmots" :key="i">
                  <td>{{ marmot.dateAndTime }}</td>
                  <td>{{ marmot.number }}</td>
                  <td>{{ marmot.length }}</td>
                  <td>{{ marmot.width }}</td>
                  <td>{{ marmot.area }}</td>
                  <td>{{ marmot.accountWithoutCC }}</td>
                  <td>{{ marmot.transCorrectionCoefficientName }}</td>
                  <td>{{ marmot.accountWithCC }}</td>
                  <td>{{ marmot.density }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('Всего') }}</b></td>
                  <td></td>
                  <td>{{ total_field(animalAccounting.marmots, 'length') }}</td>
                  <td>{{ total_field(animalAccounting.marmots, 'width') }}</td>
                  <td>{{ animalAccounting.areaMarmot }}</td>
                  <td>{{ total_field(animalAccounting.marmots, 'accountWithoutCC') }}</td>
                  <td></td>
                  <td>{{ animalAccounting.countMarmot }}</td>
                  <td>{{ animalAccounting.densityMarmot }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="table-item" v-if="animalAccounting.reportId === forms.formMarmot">
            <h6>{{ $t('Сводные сведения') }}</h6>
            <table>
              <thead>
              <tr>
                <td>{{ $t('Площадь местообитания сурка (га)') }}</td>
                <td>{{ $t('Численность особей (голов)') }}</td>
                <td>{{ $t('Средняя плотность на 1га (голов)') }}</td>
                <td>{{ $t('Лимит отлова численности (20%)') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ animalAccounting.areaMarmot }}</td>
                <td>{{ animalAccounting.countMarmot }}</td>
                <td>{{ animalAccounting.densityMarmot }}</td>
                <td>{{ animalAccounting.limitMarmot }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица Ведомость маршрутов ондатры -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formOndatra">
            <h6>{{ $t('Ведомость маршрутов') }}</h6>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td>{{ $t('Дата и время учета') }}</td>
                  <td>{{ $t('№ маршрута') }}</td>
                  <td>{{ $t('Длина маршрута (км)') }}</td>
                  <td>{{ $t('Площадь маршрута (га)') }}</td>
                  <td>{{ $t('Кол-во семей') }}</td>
                  <td>{{ $t('Кол-во нор') }}</td>
                  <td>{{ $t('Кол-во хаток') }}</td>
                  <td>{{ $t('Кол-во голов') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ondatra, i) in animalAccounting.ondatras" :key="i">
                  <td>{{ ondatra.dateAndTime }}</td>
                  <td>{{ ondatra.routeNumber }}</td>
                  <td>{{ ondatra.length }}</td>
                  <td>{{ ondatra.area }}</td>
                  <td>{{ ondatra.familyQuantity }}</td>
                  <td>{{ ondatra.burrowQuantity }}</td>
                  <td>{{ ondatra.hutsQuantity }}</td>
                  <td>{{ ondatra.headQuantity }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('Всего') }}</b></td>
                  <td></td>
                  <td>{{ total_field(animalAccounting.ondatras, 'length') }}</td>
                  <td>{{ total_field(animalAccounting.ondatras, 'area') }}</td>
                  <td>{{ total_field(animalAccounting.ondatras, 'familyQuantity') }}</td>
                  <td>{{ total_field(animalAccounting.ondatras, 'burrowQuantity') }}</td>
                  <td>{{ total_field(animalAccounting.ondatras, 'hutsQuantity') }}</td>
                  <td>{{ total_field(animalAccounting.ondatras, 'headQuantity') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="table-item" v-if="animalAccounting.reportId === forms.formOndatra">
            <h6>{{ $t('Сводные сведения') }}</h6>
            <table>
              <thead>
              <tr>
                <td align="center" rowspan="2">
                  <b> № </b>
                </td>
                <td align="center" rowspan="2">
                  <b>{{ $t('Наименование участка (хозяйства)') }}</b>
                </td>
                <td align="center" colspan="3">
                  <b>{{ $t('Учтено') }}</b>
                </td>
                <td align="center" colspan="2">
                  <b>{{ $t('Установлено') }}</b>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <b>{{ $t('нор')}}</b>
                </td>
                <td align="center">
                  <b>{{ $t('хаток') }}</b>
                </td>
                <td align="center">
                  <b>{{ $t('всего') }}</b>
                </td>
                <td align="center">
                  <b>{{ $t('приплод') }}</b>
                </td>
                <td align="center">
                  <b>{{ $t('запас') }}</b>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>1</td>
                <td>{{ animalAccounting.transObservePlotName }}</td>
                <td>{{ animalAccounting.burrowOndatraAccounted }}</td>
                <td>{{ animalAccounting.hutsOndatraAccounted }}</td>
                <td>{{ animalAccounting.totalOndatraAccounted }}</td>
                <td>{{ animalAccounting.offspringOndatraEstablished }}</td>
                <td>{{ animalAccounting.stockOndatraEstablished }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Таблица участков по числености (форма 5) -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formNumberAnimal">
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td>{{ $t('Участок') }}</td>
                  <td>{{ $t('Общая площадь') }}</td>
                  <td>{{ $t('Площадь свойственных угодий') }}</td>
                  <td>{{ $t('Плотность населения') }}</td>
                  <td>{{ $t('Численность') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(numberAnimal, i) in animalAccounting.numberAnimalArray" :key="i">
                  <td>{{ numberAnimal.observePlotName }}</td>
                  <td>{{ numberAnimal.area }}</td>
                  <td>{{ numberAnimal.landArea }}</td>
                  <td>{{ numberAnimal.density }}</td>
                  <td>{{ numberAnimal.strength }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('Всего') }}</b></td>
                  <td>{{ animalAccounting.areaNumberAnimal }}</td>
                  <td>{{ animalAccounting.landAreaNumberAnimal }}</td>
                  <td>{{ animalAccounting.densityNumberAnimal }}</td>
                  <td>{{ animalAccounting.strengthNumberAnimal }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Расстояние -->
          <div class="table-item" v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
            <table>
              <tbody>
                <tr v-if="animalAccounting.ilbirsCardType && animalAccounting.reportId !== forms.formUngulate">
                  <td>{{ $t('Тип') }}</td>
                  <td>
                    {{ animalAccounting.ilbirsCardType ? animalAccounting.ilbirsCardType.transName : '' }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Всего, включая неопр.') }}</td>
                  <td>{{ animalAccounting.total }}</td>
                </tr>
                <template v-if="animalAccounting.reportId === forms.formUngulate || (animalAccounting.ilbirsCardType && animalAccounting.ilbirsCardType.id === animalAccounting.ilbirsCardTypeVisual)">
                  <tr v-if="animalAccounting.spacing">
                    <td>{{ $t('Расстояние') }}</td>
                    <td>
                      {{ animalAccounting.spacing }}
                      <span>м</span>
                    </td>
                  </tr>
                  <tr v-if="animalAccounting.direction">
                    <td>{{ $t('Направление (азимут)') }}</td>
                    <td>
                      {{ animalAccounting.direction }}
                      <span>по компасу</span>
                    </td>
                  </tr>
                  <tr v-if="animalAccounting.fauna">
                    <td>{{ $t('Вид') }}</td>
                    <td>{{ animalAccounting.fauna ? animalAccounting.fauna.transName  : '' }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{$t('Самки')}}: <span>{{ animalAccounting.females }}</span>
                    </td>
                    <td>
                      <div class="flexbox f-span-margin">
                        <div class="td-item">
                         {{ animalAccounting.reportId === forms.formUngulate ? $t('ягн./козл. до 12 мес.') : $t('До 12 мес.') }}: <span>{{ animalAccounting.femalesTill12M }}</span>
                        </div>
                        <div class="td-item">
                          {{ $t('От 1 до 2 лет') }}: <span>{{ animalAccounting.femalesFrom1to2 }}</span>
                        </div>
                        <template v-if="animalAccounting.reportId === forms.formUngulate">
                          <div class="td-item">
                            {{ $t('Самцы 2-3 года') }}: <span>{{ animalAccounting.malesFrom2to3 }}</span>
                          </div>
                          <div class="td-item">
                            {{ $t('Самцы 4 и старше') }}: <span>{{ animalAccounting.malesFrom4to7 }}</span>
                          </div>
                          <div class="td-item">
                            {{ $t('Из них 8 и старше') }}: <span>{{ animalAccounting.malesFrom8AndHigher }}</span>
                          </div>
                        </template>
                        <template v-if="animalAccounting.ilbirsCardType && animalAccounting.ilbirsCardType.id === animalAccounting.ilbirsCardTypeVisual">
                          <div class="td-item">
                            {{ $t('4 года и >') }}: <span>{{ animalAccounting.malesFrom4AndHigher }}</span>
                          </div>
                        </template>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="table-flex" v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
            <!-- Поведение -->
            <div class="table-item">
              <table>
                <tbody>
                  <tr v-if="animalAccounting.reportId === forms.formUngulate || (animalAccounting.ilbirsCardType && animalAccounting.ilbirsCardType.id === animalAccounting.ilbirsCardTypeVisual)">
                    <td>{{ $t('Поведение') }}</td>
                    <td>{{ animalAccounting.transBehaviorName }}</td>
                  </tr>
                  <tr v-if="animalAccounting.reportId !== forms.formUngulate && animalAccounting.ilbirsCardType && animalAccounting.ilbirsCardType.id === animalAccounting.ilbirsCardTypeTrack">
                    <td>{{ $t('След') }}</td>
                    <td>{{ animalAccounting.trackType ? animalAccounting.trackType.transName : '' }}</td>
                  </tr>
                  <tr v-if="animalAccounting.reportId === forms.formUngulate || (animalAccounting.ilbirsCardType && animalAccounting.ilbirsCardType.id === animalAccounting.ilbirsCardTypeVisual)">
                    <td>{{ $t('Дистанция бегства') }}</td>
                    <td>
                      {{ animalAccounting.distance }}
                      <span>м</span>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Позиция по рельефу') }}</td>
                    <td>{{ animalAccounting.transReliefPositionName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Экспозиция по склону') }}</td>
                    <td>{{ animalAccounting.transSlopeExposureName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Крутизна') }}</td>
                    <td>{{ animalAccounting.transSteepnessName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Погода') }}</td>
                    <td>{{ animalAccounting.transWeatherName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Направление ветра') }}</td>
                    <td>{{ animalAccounting.transWindDirectionName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Сила ветра') }}</td>
                    <td>{{ animalAccounting.transWindPowerName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Грунт') }}</td>
                    <td>{{ animalAccounting.transPrimingName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Растительность') }}</td>
                    <td>{{ animalAccounting.transVegetationName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Вид воды') }}</td>
                    <td>{{ animalAccounting.transWaterTypeName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Вид землепользования') }}</td>
                    <td>{{ animalAccounting.transLandUseTypeName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Наличие домашнего скота -->
            <div class="table-item" v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
              <h6>{{ $t('Наличие домашнего скота') }}</h6>
              <table>
                <tbody>
                <tr>
                  <td>{{ $t('Козы') }}</td>
                  <td>{{ animalAccounting.presenseGoats }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Овцы') }}</td>
                  <td>{{ animalAccounting.presenseSheeps }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Яки') }}</td>
                  <td>{{ animalAccounting.presenseYak }}</td>
                </tr>
                <tr>
                  <td>{{ $t('КРС') }}</td>
                  <td>{{ animalAccounting.presenseCattle }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Лошади') }}</td>
                  <td>{{ animalAccounting.presenseHorses }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- Находки -->
            <div class="table-item" v-if="animalAccounting.reportId === forms.formUngulate || animalAccounting.reportId === forms.formIlbirs">
              <h6>{{ $t('Находки') }}</h6>
              <table>
                <tbody>
                <tr>
                  <td>{{ $t('Мертвые особи') }}</td>
                  <td>{{ animalAccounting.findsDeadIndividuals }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Останки') }}</td>
                  <td>{{ animalAccounting.findsRemains }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Свежий след') }}</td>
                  <td>{{ animalAccounting.findsFreshTrace }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Данные по другим видам / примечания -->
          <div class="table-item">
            <table>
              <tbody>
              <tr>
                <td>{{ $t('Данные по другим видам / примечания') }}</td>
                <td>{{ animalAccounting.note }}</td>
              </tr>
              <tr v-if="animalAccounting.reportId !== forms.formStrength && animalAccounting.reportId !== forms.formNumberAnimal">
                <td>{{ $t('При учете присутствовали') }}</td>
                <td>
                  <ul v-for="observer in animalAccounting.otherObservers" :key="observer.id">
                    <li>{{ observer.transFio }} {{ observer.transPosition }}</li>
                  </ul>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Файлы -->
          <div class="table-item" v-if="photos.length > 0">
            <table>
              <tbody>
              <tr>
                <td>{{ $t('Файлы') }}</td>
                <td>
                  <ul class="files-l" v-for="photo in photos" :key="photo.name">
                    <li>
                      <a :href="baseUrl + photo.link" target="_blank">{{ photo.name }}</a>
                    </li>
                  </ul>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="print">
          <v-btn @click="printWord" class="btn-print btn-print-word">{{ $t("Печать в Word") }}</v-btn>
        </div>
        <div class="reports-footer form-action">
          <template v-for="actionPermission in actionPermissions">
            <v-btn
              :key="actionPermission.id"
              @click="action(actionPermission)"
              :class="actionPermission.class"
            >
              {{ actionPermission.name }}
            </v-btn>
            <template v-if="actionPermission.type == 'animal_accounting_status' && actionPermission.comment === true">
              <v-dialog
                v-model="commentDialog[actionPermission.id]"
                scrollable
                max-width="600px"
                :key="'action_'+actionPermission.id"
              >
                <v-card class="modal observer-modal">
                  <div class="modal-head">
                    {{ $t('Добавление комментария') }}
                    <v-btn color="modal-close" @click="changeCommentDialog(actionPermission.id, false)">
                      <img src="@/assets/img/close-icon.png" alt="icon">
                    </v-btn>
                  </div>
                  <div class="modal-body">
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Комментарий') }}:
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-textarea
                          v-model="comment"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <div class="form-action">
                      <button
                        class="btn btn-default blue"
                        type="button"
                        @click="changeStatus({ id: actionPermission.id, comment: comment }), changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Добавить') }}
                      </button>
                      <button
                        class="btn btn-default gray"
                        type="button"
                        @click="changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Отмена') }}
                      </button>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </template>
          </template>
          <v-btn
            @click="onCancel"
          >
            {{ $t('Закрыть') }}
          </v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import AnimalAccounting from '@/model/animalAccounting'
import { mapMutations } from 'vuex'
import moment from 'moment'
import MapPointView from '@/components/app/MapPointView'

export default {
  components: {
    MapPointView
  },
  data: () => ({
    breadcrumbs: [],
    baseUrl: process.env.VUE_APP_BACK_URL,
    animalAccounting: {
      dateAndTimeObservation: { view: '' },
      year: { view: '' }
    },
    actionPermissions: {},
    commentDialog: [],
    comment: null,
    histories: [],
    historyDialog: false,
    mapDialog: false,
    forms: [],
    photos: []
  }),
  computed: {
    computedDateFormatted () {
      return moment(this.animalAccounting.dateAndTimeObservation.view).format('DD.MM.YYYY HH:mm')
    }
  },
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),

    fetchData () {
      this.setLoading(true)
      AnimalAccounting.view(this.$route.params.id)
        .then((response) => {
          if (response.status === 400) {
            this.$router.push({
              name: 'animal-accountings'
            })
          }
          this.animalAccounting = response.data.animalAccounting
          this.histories = response.data.animalAccounting.histories
          this.forms = response.data.animalAccounting.forms
          if (response.data.animalAccounting.photos) {
            this.photos = response.data.animalAccounting.photos
          }

          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.$i18n.t('Учет животных'), disabled: false, href: '/animal-accountings' },
            { text: this.animalAccounting.transReportNameView, disabled: true }
          ]
          this.scrollToTop()
          this.getActions(this.animalAccounting.status)
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // список действий
    getActions (statusId) {
      AnimalAccounting.getActions(statusId).then((response) => {
        this.actionPermissions = response.data
      })
    },
    // действия
    action (actionPermission) {
      if (actionPermission.type === 'animal_accounting_status') {
        if (actionPermission.comment === true) {
          this.changeCommentDialog(actionPermission.id, true)
        } else {
          this.changeStatus({ id: actionPermission.id })
        }
      } else if (actionPermission.type === 'animal_accounting_edit') {
        this.$router.push({
          name: 'account-card',
          params: { id: this.animalAccounting.id, rId: this.animalAccounting.reportId }
        })
      } else if (actionPermission.type === 'animal_accounting_delete') {
        if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
          AnimalAccounting.deleteAnimalAccounting(this.animalAccounting.id)
            .then((response) => {
              if (response.status === 200) this.$router.push({ name: 'animal-accountings' })
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    changeStatus (data) {
      AnimalAccounting.changeStatus(this.animalAccounting.id, data)
        .then((response) => {
          this.animalAccounting.statusId = response.data.statusId
          this.animalAccounting.transStatusName = response.data.transStatusName
          this.getActions(this.animalAccounting.statusId)
          this.histories = response.data.histories
        })
        .catch((error) => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // изменение статуса модального окна для комментариев
    changeCommentDialog (id, flag) {
      this.comment = null
      this.$set(this.commentDialog, id, flag)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена карточки
    onCancel () {
      this.$router.push({
        name: 'animal-accountings'
      })
    },
    // Подсчет итого для численности животных
    total (num, arr) {
      const sum = arr
        .map(item => item.strength)
        .reduce((prev, curr) => prev + curr, 0)
      return num + sum
    },
    total_field (arr, field) {
      if (arr !== undefined) {
        const sum = arr
          .map(item => item[field])
          .reduce((prev, curr) => Math.round(prev + curr), 0)
        return sum
      }
    },
    average_density (arr) {
      if (arr !== undefined && arr.length === 0) return 0
      if (arr !== undefined && arr.length > 0) {
        const sum = arr
          .map(item => item.density)
          .reduce((prev, curr) => prev + curr, 0)
        const average = parseFloat((sum / arr.length).toFixed(2))
        return average
      }
    },
    // печать в ворд
    printWord () {
      this.setLoading(true)
      AnimalAccounting.wordPrint(this.$route.params.id)
        .then(response => {
          if (response.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(response)
          }
        })
        .catch(error => {
          console.log(error)
          this.$noty.warning(this.$i18n.t('Внимание! Для данной карточки не найден шаблон.'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })

      this.setLoading(false)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'форма.docx')
      document.body.appendChild(link)
      link.click()
    },
    // вызов карты для координат
    runMap (coordinates) {
      this.mapDialog = true
      setTimeout(() => {
        this.$refs.mapRef.initCoordinates(coordinates)
      })
    }
  }
}
</script>
